import { extractPdfVisibility } from '../../directives/pdf-visibility/extractPdfVisibility';
import { PdfVisibilityDirectiveKind } from '../../directives/pdf-visibility/IPdfVisibilityDirective';
import { IBaseWidget } from '../IBaseWidget';
import { IWidgetParsedProps } from '../repository/inputs/common/util/getWidgetProps';
import { useBooleanCondition } from './useBooleanCondition';

/**
 * Hook che ritorna la visibilità di un componente.
 * I widget di tipo grafico non sono presenti nella validazione,
 * quindi richiedono di essere nascosti "manualmente" all'interno
 * dei component stessi.
 *
 * Qui viene controllato se il widget è configurato per essere visibile (vedi PdfVisibilityDirectiveType),
 * e se è configurato per essere visibile viene controllata la condizione del `visible`.
 */
export function useWidgetVisibility(
  widget: IBaseWidget,
  options: IWidgetParsedProps,
) {
  const visibilityDirectiveOptions = extractPdfVisibility(widget);
  const visibleCondition = useBooleanCondition(widget.visible, options);

  if (!visibleCondition) return false;

  // SE non si è in preview e il componente è configurato per avere una visibilità limitata al solo PDF,
  // ritorno `false`.
  // In preview (configurazione, _non_ anteprima) la visibilità non deve essere limitata.
  if (
    !options.preview &&
    visibilityDirectiveOptions?.visibility === PdfVisibilityDirectiveKind.PDF
  ) {
    return false;
  }

  return true;
}
